import { LinkIcon } from "@heroicons/react/24/solid";

const Project = () => {
  const projectList = {
    project: [
      {
        title: "CRUD",
        thumb: "/crud-thumb.jpg",
        link: "https://crud-topaz.vercel.app/crud",
        infoLink: "https://crud-topaz.vercel.app/crud",
        skills: ["Next.js", "Formik", "Yup", "Tiptap Editor", "Tailwindcss"],
        period: "2022.06.20 - 2022.07.30",
        github: "https://github.com/YSJ-Git/crud",
      },
      {
        title: "Simple Chat",
        thumb: "/chat-thumb.png",
        link: "https://react-socket-simple-chat.herokuapp.com/",
        infoLink: "https://react-socket-simple-chat.herokuapp.com/",
        skills: [
          "React",
          "nodejs",
          "express",
          "socket.io",
          "MUI",
          "Tailwindcss",
        ],
        period: "2022.08.18 - 2022.09.02",
        github: "https://github.com/YSJ-Git/react-socketio-chat",
      },
    ],
  };
  return (
    <section id="project" className="project">
      <strong className="section_tit">
        <img src="/laptop.png" alt="프로젝트 아이콘" />
        <span>프로젝트</span>
      </strong>
      <ul className="flex flex-wrap justify-between">
        {projectList.project.map((pr, idx) => (
          <li
            key={idx}
            className="w-full mb-5 border border-white rounded-lg sm:w-[48%]"
          >
            <a
              href={pr.infoLink}
              target="_blank"
              className="block hover:bg-[#b519ab] rounded-lg"
            >
              <div className="thumb bg-white rounded-t-lg flex justify-center items-center p-3">
                <img src={pr.thumb} alt={pr.title} />
              </div>
              <div className="info p-5">
                <strong className="text-base md:text-lg mb-2 block">
                  {pr.title}
                </strong>
                <p className="mb-2 text-sm">{pr.period}</p>
                <div className="">
                  <ul className="flex flex-wrap">
                    {pr.skills.map((skill, idx) => (
                      <li
                        key={idx}
                        className="pt-mono inline-block bg-gray-700 py-1 px-2 rounded text-sky-300 mr-2 mb-2 text-sm"
                      >
                        {skill}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <a
                      href={pr.github}
                      target="_blank"
                      className="text-sm hover:text-sky-300 underline"
                    >
                      Github
                    </a>
                  </div>
                  <div>
                    <a href={pr.link} target="_blank">
                      <LinkIcon className="w-6 h-6 bg-purple-500 p-[5px] rounded-full hover:fill-sky-500 hover:bg-white" />
                    </a>
                  </div>
                </div>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Project;
